///ts:ref=UIWindow
/// <reference path="./UIWindow.ts"/> ///ts:ref:generated

interface ITowerPair {
	skin: TowerDesc;
	dict: MobDict;
}

class TowerShop extends UIWindow {
	panel: PIXI.Sprite;
	base: Base;

	tw: Array<BuyTower>;

	constructor() {
		super();

		this.visible = false;

		let shop: Array<ITowerPair> = [
			{skin: Assets.allTowers[0], dict: Game.dicts.defence},
			{skin: Assets.allTowers[1], dict: Game.dicts.machineGun},
			{skin: Assets.allTowers[3], dict: Game.dicts.sniper},
			{skin: Assets.allTowers[4], dict: Game.dicts.mortar}
		];

		this.panel = new PIXI.Sprite(Assets.ui.panel_square);
		centerFrickingSprite(this.panel);
		this.addChild(this.panel);

		this.tw = [];
		for (let i = 0; i < 4; i++) {
			let btn = new BuyTower(shop[i]);
			btn.position.set(i % 2 * 90 - 45, (i >> 1) * 90 - 45);
			this.tw.push(btn);
			this.addChild(btn);
		}

		this.on('buyTower', (tower: ITowerPair) => {
			const base = this.base;
			if (!base) return;
			base.spawn(tower);
			this.hide();
			// base.spawn
		});
	}

	show(base: Base) {
		Interact.showWnd(this);
		this.base = base;
		this.position.copy(base.position);
		this.visible = true;
		this.update();
	}

	hide() {
		Interact.hideWnd(this);
		this.base = null;
		this.visible = false;
	}

	update() {
		for (let i = 0; i < 4; i++) {
			this.tw[i].update();
		}
	}
}
